module.exports = __webpack_public_path__ + "media/images/cogwheel-3f2a3c6f.svg";